import React from "react";
import "./ScrollJumpButton.css";

export default function ScrollJumpButton({ direction, destination, onClick, className = "" }) {
  return <button className={`mb-scrollJump ${className}`} type="button" onClick={onClick}>
    {direction === "up" ? "↑" : "↓"} Scroll {direction} to {destination}
  </button>;
}
